// Color presets for export customization
export const COLOR_PRESETS = {
  primary: [
    { name: 'Indigo', value: '#6366f1' },
    { name: 'Blue', value: '#3b82f6' },
    { name: 'Cyan', value: '#06b6d4' },
    { name: 'Teal', value: '#14b8a6' },
    { name: 'Green', value: '#10b981' },
    { name: 'Purple', value: '#8b5cf6' },
    { name: 'Slate', value: '#475569' },
    { name: 'Navy', value: '#1e3a5f' },
  ],
  accent: [
    { name: 'Pink', value: '#ec4899' },
    { name: 'Rose', value: '#f43f5e' },
    { name: 'Orange', value: '#f97316' },
    { name: 'Amber', value: '#f59e0b' },
    { name: 'Lime', value: '#84cc16' },
    { name: 'Emerald', value: '#10b981' },
    { name: 'Violet', value: '#8b5cf6' },
    { name: 'Fuchsia', value: '#d946ef' },
  ],
};

// Default export configuration
export const DEFAULT_EXPORT_CONFIG = {
  colors: {
    primary: '#6366f1',
    accent: '#d946ef',
  },
  branding: {
    companyName: 'StatFalcon',
  },
  text: {
    title: '',
    subtitle: '',
    footerText: '',
  },
  exportType: 'pdf', // 'pdf' | 'pptx' | 'csv'
  granularity: 'day', // 'day' | 'week' | 'month' | 'all' (reports only)
  sections: {}, // { [pageType]: { [sectionKey]: bool } } — missing key => section default
};

// Page-specific default text based on report type
export const PAGE_DEFAULTS = {
  dashboard: {
    title: 'Dashboard Report',
    subtitle: 'Overview of key performance metrics',
  },
  analytics: {
    title: 'Web Analytics Report',
    subtitle: 'Traffic and engagement insights',
  },
  reports: {
    title: 'Ad Performance Report',
    subtitle: 'Campaign and ad analytics',
  },
};

// LocalStorage key for persisting export config
export const STORAGE_KEY = 'exportBuilderConfig';

// Helper to load config from localStorage. Merges nested objects so configs
// saved by older versions (missing new keys) fall back to defaults.
export const loadExportConfig = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...DEFAULT_EXPORT_CONFIG,
        ...parsed,
        colors: { ...DEFAULT_EXPORT_CONFIG.colors, ...parsed.colors },
        branding: { ...DEFAULT_EXPORT_CONFIG.branding, ...parsed.branding },
        text: { ...DEFAULT_EXPORT_CONFIG.text, ...parsed.text },
        sections: parsed.sections || {},
      };
    }
  } catch (e) {
    console.error('Failed to load export config:', e);
  }
  return DEFAULT_EXPORT_CONFIG;
};

// Helper to save config to localStorage
export const saveExportConfig = (config) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch (e) {
    console.error('Failed to save export config:', e);
  }
};

// Convert hex to RGB array for jsPDF
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : [99, 102, 241];
};

// Convert hex to uppercase (no #) for pptxgenjs
export const hexToPptx = (hex) => {
  return hex.replace('#', '').toUpperCase();
};
